import { observer } from 'mobx-react'
import { useContext } from 'react'
import { Header } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { Illustration } from '@/components/Illustration/Illustration'

export const TransactionCompletedPage = observer(() => {
  const store = useContext(StoreContext)
  const { transactionCompletedPage: trans, errorPage: transError } =
    store.TranslationsState.translations

  const location = window.location.href
  const url = new URL(location)
  const isError = url.searchParams.get('error')

  if (!!isError)
    return (
      <div className="page-container mobile-m-0 vertically-centered">
        <Illustration type="transaction-cancelled" />
        <Header className="m-0-0-30">{transError?.title}</Header>
      </div>
    )

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <Illustration type="success" />
      <Header className="m-0-0-30">{trans?.header}</Header>
    </div>
  )
})
